import styled from 'styled-components'

import { IconProps } from '@/components/Icons'
import BaseSvg from '@/components/Icons/BaseSvg'

const StyledIcon = styled<any>(BaseSvg)`
  width: 20px;
  height: 20px;
`
const FeatureTriggerIcon = (props: IconProps) => (
  <StyledIcon viewBox="0 0 48 48" width={48} height={48} fill="none" {...props}>
    <path
      fill="#002AB4"
      fillRule="evenodd"
      d="M15.798 2.123c.43.741.151 1.675-.621 2.087L3.2 10.593v25.48l11.977 6.383c.772.412 1.05 1.346.621 2.087-.429.742-1.403 1.008-2.175.597l-12.8-6.822A1.526 1.526 0 0 1 0 36.977V9.69c0-.557.315-1.071.823-1.342l12.8-6.821c.772-.412 1.746-.145 2.175.596ZM33.518 44.544c-.393-.741-.138-1.676.57-2.088l10.979-6.383v-25.48L34.088 4.21c-.708-.412-.963-1.346-.57-2.087.393-.741 1.286-1.008 1.995-.596l11.733 6.821c.465.271.754.785.754 1.342v27.287c0 .557-.289 1.07-.754 1.341L35.513 45.14c-.709.411-1.602.145-1.995-.596Z"
      clipRule="evenodd"
    />
    <path
      fill="#002AB4"
      fillRule="evenodd"
      d="M23.38 6.835a1.224 1.224 0 0 1 1.24 0l14.77 8.667c.377.222.61.63.61 1.07v14.857c0 .44-.233.847-.61 1.07l-14.77 8.666a1.225 1.225 0 0 1-1.24 0L8.61 32.498a1.24 1.24 0 0 1-.61-1.07V16.572c0-.44.233-.847.61-1.069l14.77-8.667ZM10.462 18.727l12.307 7.222v11.99l-12.307-7.221v-11.99ZM25.23 37.94l12.307-7.222v-11.99l-12.307 7.221v11.99ZM24 23.805l12.327-7.233L24 9.338l-12.327 7.234L24 23.805Z"
      clipRule="evenodd"
    />
  </StyledIcon>
)

FeatureTriggerIcon.displayName = 'FeatureTriggerIcon'
export default FeatureTriggerIcon
